// @ts-check

/**
 * 
 * Causes the browser to download a csv file with the given data and file name
 * 
 * Future note: This should have a better method of allowing you to specify
 * the order of the cols than relying on order of props which is not guaranteed to 
 * be preserved in JS.
 * 
 * @param {Array<{[key: string]:string|number}>} data 
 * @param {string} filename 
 */
export function downloadCsv(data, filename) {
    download(encodeURI(arrayOfObjectsToCsvHref(data)), filename);
}

/**
 * Turns an array of objects to a CSV data href.
 * 
 * Caveates: Instead of escapeing this just removes characters it thinks are bad
 * and it may not know about all possible bad csv characters. Perhaps a 3rd party
 * library here would eventually be better.
 * 
 * @param {*} arr 
 */
function arrayOfObjectsToCsvHref(arr) {
    const array = [Object.keys(arr[0])].concat(arr);
    return 'data:text/csv;charset=utf-8,'
        + array.map(it => {
            return Object.values(it).map(value => {
                return String(value)
                    .replace(new RegExp("\\#|\\,|\\'|\\\"|\n|\t", "g"), '')
            }).join(',')
        }).join('\n')
}

/**
 * Causes the browser to download a file with the given data-uri/href and file name
 * 
 * Caveates: This probably doesn't work in IE11
 * 
 * @param {*} uri 
 * @param {*} filename 
 */
function download(uri, filename) {
    const link = document.createElement('a');
    if (typeof link.download === 'string') {
        document.body.appendChild(link); // Firefox requires the link to be in the body
        link.download = filename;
        link.href = uri;
        link.click();
        document.body.removeChild(link); // remove the link when done
    } else {
        location.replace(uri);
    }
}